/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'THE_FACILITY_SPONSORED__PAID_FOR_AND_OR_ORGANIZED__A_COMMUNITY_',
              'WORKERS_WERE_ENCOURAGED_TO_VOLUNTARILY_ENGAGE_IN_COMMUNITY_SERV',
              'WORKERS_WERE_PERMITTED_CERTAIN_HOURS_TO_VOLUNTARILY_ENGAGE_IN_C',
              'BLOOD_DONATION_PROGRAMS',
              'GENDER_EQUALITY_AND_EMPOWERMENT_PROGRAMS',
              'OTHER',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    did_the_fac_participate_in_any_of_the_following_activities_rela: valueSchema,
  },
}
